import Axios from 'axios';
import { API_HOST, axiosInstance, axiosRequestWithAuth } from './../constants/server.constant';
export const NetworkService = {
    allocatePrivateIpv4,
    getGateWay,
    getIPDetails,
    deleteIP,
    addPublicIp,
    getIPDetailsByUser
};

function getuserId() {
    return localStorage.getItem("userId");
}

function allocatePrivateIpv4(serverId, regionUrl, regionName, reboot) {
    const region = regionUrl;
    return axiosInstance.post(API_HOST + "/networks/ip/" + getuserId() + "/" + serverId + '?region=' + region + "&regionName=" + regionName + "&reboot=" + reboot, {}, axiosRequestWithAuth).then((resp) => {
        return resp;
    }).catch((error) => {
        return false;
    });
}

function getGateWay(serverId, region) {
    return axiosInstance.get(API_HOST + "/networks/getgateway/" + serverId + '/' + region + "/" + getuserId(), axiosRequestWithAuth).then((resp) => {
        return resp;
    }).catch((error) => {
        return false;
    });
}

function getIPDetails(serverId) {
    return axiosInstance.get(API_HOST + "/networks/getips/" + serverId + "/" + getuserId(), axiosRequestWithAuth).then((resp) => {
        return resp;
    }).catch((error) => {
        return false;
    });
}
function getIPDetailsByUser() {
    return axiosInstance.get(API_HOST + "/networks/getipsbyuser/" + getuserId(), axiosRequestWithAuth).then((resp) => {
        return resp;
    }).catch((error) => {
        return false;
    });
}

function deleteIP(serverId, region, ip, name) {
    return axiosInstance.delete(API_HOST + "/networks/publicip/" + serverId + "/" + getuserId() + '?region=' + region + "&ipvalue=" + ip + '&name=' + name, axiosRequestWithAuth).then((resp) => {
        return resp;
    }).catch((error) => {
        return false;
    });
}

function addPublicIp(serverId, region, name) {
    return axiosInstance.post(API_HOST + "/networks/publicip/" + serverId + "/" + getuserId() + '?region=' + region + '&name=' + name, {}, axiosRequestWithAuth).then((resp) => {
        return resp;
    }).catch((error) => {
        return false;
    });
}

